<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Modal close -->
  <div
    class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
    v-show="uploadModal"
    @click="uploadModal = false"
  />

  <vue-final-modal
    v-model="uploadModal"
    classes="base-modal"
    :ssr="true"
    :content-class="
      darkMode
        ? 'add-modal bg-darkmode-base transition-colors duration-1000'
        : 'add-modal bg-white transition-colors duration-1000'
    "
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="where.submenu === 'Position'">Position Form</h1>
      <h1 v-else-if="where.submenu === 'Branch'">Branch Form</h1>
      <h1 v-else-if="where.submenu === 'Contract'">Contract Form</h1>
      <h1 v-else-if="where.submenu === 'employeecareerpath'">
        Employee Career Path Form
      </h1>
      <h1 v-else-if="where.submenu === 'Retirement'">Retirement Form</h1>
      <h1 v-else-if="where.submenu === 'employeetraining'">Training Form</h1>
      <h1 v-else-if="where.submenu === 'Education'">Educational Record Form</h1>
      <h1 v-else-if="where.submenu === 'Certification'">Certification Form</h1>
      <h1 v-else-if="where.submenu === 'Work'">Working Experiences Form</h1>
      <h1 v-else-if="where.submenu === 'Family'">Family Form</h1>
      <h1 v-else-if="where.submenu === 'Appreciation'">Appreciation Form</h1>
      <h1 v-else-if="where.submenu === 'programme'">Programme Form</h1>
      <h1 v-else-if="where.submenu === 'punishmentTransaction'">
        Warning Form
      </h1>
      <h1 v-else>Add Form</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="uploadModal = false"
      />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <position-form
        v-if="where.submenu === 'Position'"
        :prop-class="where"
        :prop-object="EditObject"
        :prop-position="positionData.value"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <employee-career-path-form
        v-else-if="where.submenu === 'employeecareerpath'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <branch-form
        v-else-if="where.submenu === 'Branch'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <contract-form
        v-else-if="where.submenu === 'Contract'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <employee-training-form
        v-else-if="where.submenu === 'employeetraining'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <retirement-form
        v-else-if="where.submenu === 'Retirement'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <edu-form
        v-else-if="where.submenu === 'Education'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <certification-form
        v-else-if="where.submenu === 'Certification'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <work-form
        v-else-if="where.submenu === 'Work'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <family-form
        v-else-if="where.submenu === 'Family'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <appreciation-form
        v-else-if="where.submenu === 'Appreciation'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <programme-form
        v-else-if="where.submenu === 'programme'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <violation-form
        v-else-if="where.submenu === 'Violation'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <punishment-transaction-form
        v-else-if="where.submenu === 'punishmentTransaction'"
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
      <upload-form
        v-else
        :prop-class="where"
        :prop-object="EditObject"
        :show-edit="showEdit"
        @close-modal="hideModal"
      />
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="where.submenu === 'Position'">Position Detail</h1>
      <h1 v-else-if="where.submenu === 'employeecareerpath'">
        Employee Career Path Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Branch'">Branch Detail</h1>
      <h1 v-else-if="where.submenu === 'Contract'">Contract Detail</h1>
      <h1 v-else-if="where.submenu === 'Retirement'">Retirement Detail</h1>
      <h1 v-else-if="where.submenu === 'employeetraining'">Training Detail</h1>
      <h1 v-else-if="where.submenu === 'Education'">
        Educational Record Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Certification'">
        Certification Detail
      </h1>
      <h1 v-else-if="where.submenu === 'Work'">Working Experiences Detail</h1>
      <h1 v-else-if="where.submenu === 'Family'">Family Detail</h1>
      <h1 v-else-if="where.submenu === 'Appreciation'">Appreciation Detail</h1>
      <h1 v-else-if="where.submenu === 'programme'">Programme Detail</h1>
      <h1 v-else-if="where.submenu === 'punishmentTransaction'">
        Warning Detail
      </h1>
      <h1 v-else>Detail</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="detailModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <position-detail
        v-if="where.submenu === 'Position'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <employee-career-path-detail
        v-else-if="where.submenu === 'employeecareerpath'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <branch-detail
        v-else-if="where.submenu === 'Branch'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <contract-detail
        v-else-if="where.submenu === 'Contract'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <employee-training-detail
        v-else-if="where.submenu === 'employeetraining'"
        :prop-class="where"
        :propEmployeeTraining="EditObject"
        @close-modal="hideModal"
      />
      <retirement-detail
        v-else-if="where.submenu === 'Retirement'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <edu-detail
        v-else-if="where.submenu === 'Education'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <certification-detail
        v-else-if="where.submenu === 'Certification'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <work-detail
        v-else-if="where.submenu === 'Work'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <family-detail
        v-else-if="where.submenu === 'Family'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <appreciation-detail
        v-else-if="where.submenu === 'Appreciation'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <programme-detail
        v-else-if="where.submenu === 'programme'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <violation-detail
        v-else-if="where.submenu === 'Violation'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <punishment-transaction-detail
        v-else-if="where.submenu === 'punishmentTransaction'"
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
      <upload-detail
        v-else
        :prop-class="where"
        :prop-object="EditObject"
        @close-modal="hideModal"
      />
    </div>
  </vue-final-modal>
<!-- Modal Position Is Main Function -->
  <vue-final-modal
    v-model="informationModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="informationModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <div class="w-full px-4 py-6">
        <p>
          This Employee has been assigned for {{ mainup.position_name }} -
          {{ mainup.department_name }} as his / her Main Job. Do you want to
          change into this record as his / her Main Job?
        </p>
      </div>

      <jb-buttons
        class="flex justify-center w-full"
        style="padding: 15px !important"
      >
        <jb-button label="Yes" color="info" @click="updateMain" class="w-1/2" />
        <jb-button
          label="No"
          color="danger"
          outline
          @click="informationModal = false"
          class="w-2/5"
        />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <vue-final-modal
    v-model="positionActiveModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="positionActiveModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <div class="w-full px-4 py-6">
        <p>
          Are you sure you want to do this to the employee?
        </p>
      </div>

      <jb-buttons
        class="flex justify-center w-full"
        style="padding: 15px !important"
      >
        <jb-button label="Yes" color="info" @click="updateIsActive" class="w-1/2" />
        <jb-button
          label="No"
          color="danger"
          outline
          @click="positionActiveModal = false"
          class="w-2/5"
        />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <!-- view file modal -->
  <vue-final-modal
    v-model="viewFileModal"
    classes="base-modal"
    :ssr="true"
    content-class="medium-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Show file</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="viewFileModal = false"
      />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <img
        :src="fileData.file"
        alt="Preview image"
        v-if="['png', 'jpg', 'jpeg'].includes(fileData.type)"
        style="width: 100%"
      />

      <!-- Show PDF using vue-pdf-embed -->
      <vue-pdf-embed
        v-else-if="fileData.type === 'pdf'"
        :source="fileData.file"
        style="width: 100% !important; height: 100% !important"
      />

      <!-- Fallback message -->
      <span class="text-4xl" v-else>File Not Found</span>
    </div>
  </vue-final-modal>

  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="grid grid-cols-1 lg:grid-cols-4 w-full gap-2 mx-4">
      <div class="col-span-2">
        <table class="table-fixed bg-white w-full">
          <tbody>
            <tr>
              <td>{{ $t("employee.section") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.section }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("workunit.title") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.satker_name }}
              </td>
            </tr>
            <!-- <tr>
                            <td>{{ $t('Superordinate') }}</td>
                            <td class="text-base font-base text-gray-500">{{ employee.must_approve_name }}</td>
                        </tr> -->
            <!-- <tr>
                            <td>{{ $t('employee.status') }}</td>
                            <td class="text-base font-base text-gray-500">{{ employee.status }}</td>
                        </tr> -->
            <tr>
              <td>{{ $t("employee.ein") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.ein }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("students.cardNumber") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.id_card_no }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("Status") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.state }}
              </td>
            </tr>
            <tr v-if="employee.state == 'Permanent'">
              <td>{{ $t("Decree No.") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.decree_no }}
              </td>
            </tr>
            <tr v-if="employee.state == 'Permanent'">
              <td>{{ $t("Decree Date") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ formatDate(employee.decree_date) }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("Retirement Age") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ employee.retirement_age }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("Retirement Date") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ formatDate(employee.retirement_date) }}
              </td>
            </tr>
            <tr>
              <td>{{ $t("Resignation Date") }}</td>
              <td class="text-base font-base text-gray-500">
                {{ formatDate(employee.resignation_date) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-span-2">
        <card-component rounded="">
          <div
            class="grid grid-cols-1 lg:grid-cols-5 w-full gap-4 lg:gap-2 items-center"
          >
            <div
              class="w-full lg:col-span-2 flex justify-center lg:justify-start"
            >
              <img
                :src="image.get"
                :alt="employee.name"
                v-if="image.get"
                class="rounded-full w-32 md:w-48 lg:w-64 max-w-full object-cover"
              />
              <img
                src="@/assets/general/default-user.png"
                :alt="employee.name"
                v-else
                class="rounded-full w-32 md:w-48 lg:w-64 max-w-full object-cover"
              />
            </div>
            <div
              class="space-y-3 text-center lg:text-left lg:mx-5 col-span-3 flex flex-col justify-center"
            >
              <h1 class="text-2xl font-bold">{{ employee.name }}</h1>
              <p>
                Nickname <b>{{ employee.nickname }}</b>
              </p>
              <div class="flex justify-center lg:justify-start">
                <pill
                  :text="employee.is_active === 1 ? 'Active' : 'Not Active'"
                  type="info"
                  :icon="
                    employee.is_active === 1
                      ? mdiCheckDecagram
                      : mdiAlertDecagram
                  "
                />
              </div>
            </div>
          </div>
        </card-component>
      </div>
    </div>
    <div class="student-tab">
      <div class="tab-list bg-gray-50 dark:bg-gray-900">
        <div class="tab-container">
          <div
            class="content-tab"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="activeTab === tab.index ? 'active-tab' : ''"
            @click="activeTab = tab.index"
          >
            <p>{{ tab.name }}</p>
            <div class="line-tab" />
          </div>
        </div>
      </div>

      <div class="w-full bg-white p-3 text-center mx-auto border">
        <div v-if="activeTab === 0" class="w-full">
          <table>
            <tbody>
              <tr>
                <td>{{ $t("employee.idCard") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.id_card }}
                </td>
                <td>{{ $t("candidate.familycardId") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.familycard_id }}
                </td>
              </tr>
              <!-- <tr>
                        <td colspan="2" v-if="employee.idcard_filename">{{ employee.idcard_filename }}</td>
                        <td colspan="2" v-else><input type="file" accept="image/*, .pdf, .doc, .docx" v-on:change="onFileChange($event, 'idcard')" class="form-control-file" id="idcardFile"></td>
                        <td colspan="2" v-if="employee.familycard_filename">{{ employee.familycard_filename }}</td>
                        <td colspan="2" v-else><input type="file" accept="image/*, .pdf, .doc, .docx" v-on:change="onFileChange($event, 'familycard')" class="form-control-file" id="familycardFile"></td>
                    </tr> -->
              <tr>
                <td>{{ $t("employee.passport") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.passport }}
                </td>
                <td>{{ $t("employee.taxIdNumber") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.tin }}
                </td>
              </tr>
              <!-- <tr>
                        <td colspan="2"><input type="file" accept="image/*, .pdf, .doc, .docx" v-on:change="onFileChange($event, 'passport')" class="form-control-file" id="passportFile"></td>
                        <td colspan="2"><input type="file" accept="image/*, .pdf, .doc, .docx" v-on:change="onFileChange($event, 'tin')" class="form-control-file" id="tinFile"></td>
                    </tr> -->
              <tr>
                <td>{{ $t("employee.placeOfBirth") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.place_of_birth }}
                </td>
                <td>{{ $t("employee.dateOfBirth") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.date_of_birth }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("vacode.bankName") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.bank }}
                </td>
                <td>{{ $t("employee.bankAccount") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.bank_account }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.healthcare") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.healthcare }}
                </td>
                <td>{{ $t("employee.socialSecurity") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.social_security }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.religion") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.religion }}
                </td>
                <td>{{ $t("employee.ethnic") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.ethnic }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.married") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.married }}
                </td>
                <td>{{ $t("employee.gender") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.gender }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.phoneNum") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.telp }}
                </td>
                <td>{{ $t("employee.mobileNum") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.mobile_no }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.email") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.email }}
                </td>
                <td>{{ $t("schoolidentity.website") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.website }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.facebook") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.facebook }}
                </td>
                <td>{{ $t("employee.twitter") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.twitter }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.startWorking") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.start_working }}
                </td>
                <td>{{ $t("candidate.blood") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.bloodtype }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("employee.address") }}</td>
                <td colspan="3" class="text-base font-base text-gray-500">
                  {{ employee.address }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("class.createdAt") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.created_at }}
                </td>
                <td>{{ $t("class.createdBy") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.created_by }}
                </td>
              </tr>
              <tr>
                <td>{{ $t("class.updatedAt") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.updated_at }}
                </td>
                <td>{{ $t("class.updatedBy") }}</td>
                <td class="text-base font-base text-gray-500">
                  {{ employee.updated_by }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="activeTab === 1" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Position')"
          />
          <jb-button
            class="mb-2"
            color="warning"
            label="Download"
            :icon="mdiDownload"
            small
            @click="downloadAllPDFs('Position')"
          />

          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Department</td>
                  <td>{{ $t("position.title") }}</td>
                  <td>Date</td>
                  <td>Decree</td>
                  <td>{{ $t("vaccines.description") }}</td>
                  <td>Main Function</td>
                  <td>Active</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(position, index) in positionData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ position.department_name }}</td>
                  <td>{{ position.position_name }}</td>
                  <td>{{ position.tmt }}</td>
                  <td>{{ position.sk }}</td>
                  <td>{{ position.description }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        class="mb-2"
                        color="grey"
                        style="background-color: grey; color: white"
                        :icon="mdiCheckCircle"
                        small
                        @click="updateMainData(true, position)"
                        v-if="!position.is_main || position.is_main == false"
                      />
                      <jb-button
                        class="mb-2"
                        color="success"
                        :icon="mdiCheckCircle"
                        small
                        @click="updateMainData(false, position)"
                        v-else
                      />
                    </jb-buttons>
                  </td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        class="mb-2"
                        color="grey"
                        style="background-color: grey; color: white"
                        :icon="mdiCheckCircle"
                        small
                        @click="updateActiveData(true, position)"
                        v-if="!position.is_active || position.is_active == false"
                      />
                      <jb-button
                        class="mb-2"
                        color="success"
                        :icon="mdiCheckCircle"
                        small
                        @click="updateActiveData(false, position)"
                        v-else
                      />
                    </jb-buttons>
                  </td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(position, 'employeeposition')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Position', position)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Position', position)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 2" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('employeecareerpath')"
          />
          <jb-button
            class="mb-2"
            color="warning"
            label="Download"
            :icon="mdiDownload"
            small
            @click="downloadAllPDFs('CareerPath')"
          />
          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Employee</td>
                  <td>Career Path</td>
                  <td>Start Date</td>
                  <td>Decree No</td>
                  <td>Decree Expire Date</td>
                  <td>Decree file</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    employeecareerpath, index
                  ) in employeeCareerPathData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ employeecareerpath.employee_name }}</td>
                  <td>{{ employeecareerpath.career_path_name }}</td>
                  <td>{{ employeecareerpath.start_date }}</td>
                  <td>{{ employeecareerpath.decree_no }}</td>
                  <td>{{ employeecareerpath.decree_expire_date }}</td>
                  <td>{{ employeecareerpath.file_name }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        color="warning"
                        :icon="mdiDownload"
                        small
                        @click="
                          download(
                            'employeecareerpath',
                            employeecareerpath.filename
                          )
                        "
                      />
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="
                          deleteFile(employeecareerpath, 'employee-career-path')
                        "
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="
                          editData('employeecareerpath', employeecareerpath)
                        "
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="
                          detailData('employeecareerpath', employeecareerpath)
                        "
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 3" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Branch')"
          />

          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Branch</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(branch, index) in branchData.value" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ branch.branch_name }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(branch, 'employeebranch')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Branch', branch)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Branch', branch)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 4" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Retirement')"
          />
          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>{{ $t("employee.retirement") }}</td>
                  <td>{{ $t("vaccines.description") }}</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(retire, index) in retireData.value" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ retire.date }}</td>
                  <td>{{ retire.remarks }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(retire, 'retirement')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Retirement', retire)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Retirement', retire)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <div v-if="activeTab===3">
                <jb-button class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addData('salary')" />
                <table class="border-dashed w-full col-span-2">
                    <thead>
                        <tr>
                            <td>No</td>
                            <td>{{ $t('academicyear.date') }}</td>
                            <td>{{ $t('employee.salary') }}</td>
                            <td>SK</td>
                            <td>{{ $t('vaccines.description') }}</td>
                            <td>{{ $t('class.isActive') }}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(salary, index) in salaryData.value" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ salary.date }}</td>
                            <td>{{ salary.salary }}</td>
                            <td>{{ salary.sk }}</td>
                            <td>{{ salary.description }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
        <div v-if="activeTab === 5" class="table-container">
          <!-- <jb-button v-if="checkUser" class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small @click="addData('employeetraining')" /> -->
          <jb-button
            class="mb-2"
            color="warning"
            label="Download"
            :icon="mdiDownload"
            small
            @click="downloadAllPDFs('employeetraining')"
          />
          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Name</td>
                  <td>Organizer</td>
                  <td>Venue</td>
                  <td>Start Date</td>
                  <td>End Date</td>
                  <td>External Training?</td>
                  <td>Certificate No</td>
                  <td>Certificate Exp Date</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    employeetraining, index
                  ) in employeeTrainingData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ employeetraining.name }}</td>
                  <td>{{ employeetraining.organizer }}</td>
                  <td>{{ employeetraining.venue }}</td>
                  <td>{{ employeetraining.start_date }}</td>
                  <td>{{ employeetraining.end_date }}</td>
                  <td>{{ employeetraining.is_external ? "Yes" : "No" }}</td>
                  <td>{{ employeetraining.certificate_no }}</td>
                  <td>{{ employeetraining.certificate_exp_date }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="
                          deleteFile(employeetraining, '/employee-training')
                        "
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('employeetraining', employeetraining)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="
                          detailData('employeetraining', employeetraining)
                        "
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 6" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Contract')"
          />

          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Decree No.</td>
                  <td>Decree Date</td>
                  <td>Period End Date</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(contract, index) in contractData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ contract.decree_no }}</td>
                  <td>{{ contract.decree_date }}</td>
                  <td>{{ contract.period_end_date }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(contract, 'employeecontract')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Contract', contract)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Contract', contract)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 7" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Education')"
          />
          <jb-button
            class="mb-2"
            color="warning"
            label="Download"
            :icon="mdiDownload"
            small
            @click="downloadAllPDFs('Education')"
          />
          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Degree</td>
                  <td>Institution</td>
                  <td>Year of Graduation</td>
                  <td>Diploma No.</td>
                  <td>Description</td>
                  <td>Diploma File.</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(education, index) in educationData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ education.degree }}</td>
                  <td>{{ education.school }}</td>
                  <td>{{ education.graduate }}</td>
                  <td>{{ education.sk }}</td>
                  <td>{{ education.remarks }}</td>
                  <td>{{ education.file }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        color="warning"
                        :icon="mdiDownload"
                        small
                        @click="download('education', education.file)"
                      />
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(education, 'employeeschool')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Education', education)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Education', education)"
                      />
                    </jb-buttons>
                  </td>
                  <!-- <td v-html="journal.comment"></td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <table class="border-dashed w-full col-span-2 mt-2">
                    <thead>
                        <tr>
                            <td>No</td>
                            <td>{{$t('vaccines.description')}}</td>
                            <td>{{$t('candidate.submenu')}}</td>
                            <td>{{$t('lessonplan.file')}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Education')" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ attachment.description }}</td>
                            <td>{{ attachment.submenu }}</td>
                            <td>{{ attachment.filename }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table> -->
        </div>
        <div v-if="activeTab === 8" class="table-container">
          <jb-button
            v-if="checkUser"
            class="mb-2"
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addData('Certification')"
          />
          <jb-button
            class="mb-2"
            color="warning"
            label="Download"
            :icon="mdiDownload"
            small
            @click="downloadAllPDFs('Certification')"
          />
          <div class="overflow-x-auto whitespace-nowrap">
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Certificate Name</td>
                  <td>Issuer {{ $t("certification.institution") }}</td>
                  <td>Expired Date</td>
                  <td>{{ $t("vaccines.description") }}</td>
                  <td>{{ $t("lessonplan.file") }}</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(certification, index) in certificateData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ certification.certificate }}</td>
                  <td>{{ certification.institute }}</td>
                  <td>{{ certification.expired_date }}</td>
                  <td>{{ certification.remarks }}</td>
                  <td>{{ certification.file }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        color="warning"
                        :icon="mdiDownload"
                        small
                        @click="download('Certification', certification.file)"
                      />
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(certification, 'certification')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Certification', certification)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Certification', certification)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <table class="border-dashed w-full col-span-2 mt-2">
                    <thead>
                        <tr>
                            <td>No</td>
                            <td>{{$t('vaccines.description')}}</td>
                            <td>{{$t('candidate.submenu')}}</td>
                            <td>{{$t('lessonplan.file')}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Certification')" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ attachment.description }}</td>
                            <td>{{ attachment.submenu }}</td>
                            <td>{{ attachment.filename }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table> -->
        </div>
        <div v-if="activeTab === 9" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('Work')"
            />
            <jb-button
              class="mb-2"
              color="warning"
              label="Download"
              :icon="mdiDownload"
              small
              @click="downloadAllPDFs('Work')"
            />
          </div>
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false">Menu: <i>Work Expirence</i></p>
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>{{ $t("employee.startYear") }}</td>
                  <td>{{ $t("employee.endYear") }}</td>
                  <td>Employer</td>
                  <td>Last Position</td>
                  <td>{{ $t("vaccines.description") }}</td>
                  <td>Last Salary</td>
                  <td>Recommendation File</td>
                  <td v-if="showActionColumn">Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(work, index) in workingData.value" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ work.startyear }}</td>
                  <td>{{ work.endyear }}</td>
                  <td>{{ work.place }}</td>
                  <td>{{ work.position }}</td>
                  <td>{{ work.remarks }}</td>
                  <td>{{ work.salary }}</td>
                  <td>{{ work.file }}</td>
                  <td v-if="showActionColumn">
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(work, 'workexp')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Work', work)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Work', work)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <table class="border-dashed w-full col-span-2 mt-2">
                    <thead>
                        <tr>
                            <td>No</td>
                            <td>{{$t('vaccines.description')}}</td>
                            <td>{{$t('candidate.submenu')}}</td>
                            <td>{{$t('lessonplan.file')}}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(attachment, index) in attachmentData.value.filter(item => item.submenu === 'Work')" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ attachment.description }}</td>
                            <td>{{ attachment.submenu }}</td>
                            <td>{{ attachment.filename }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table> -->
        </div>
        <div v-if="activeTab === 10" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('Family')"
            />
          </div>
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false" class="mb-4">
              Menu: <i>Employee Family</i>
            </p>
            <table class="table border-dashed w-full col-span-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>{{ $t("class.name") }}</td>
                  <td>{{ $t("family.relation") }}</td>
                  <td>{{ $t("employee.dateOfBirth") }}</td>
                  <td>{{ $t("family.isEmployee") }}</td>
                  <td>{{ $t("family.isStudent") }}</td>
                  <td>{{ $t("employee.mobileNum") }}</td>
                  <td>{{ $t("employee.email") }}</td>
                  <td>Remarks</td>
                  <td v-if="showActionColumn">Action</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(family, index) in familyData.value" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ family.name }}</td>
                  <td>{{ family.relation }}</td>
                  <td>{{ family.date_of_birth }}</td>
                  <td>{{ family.is_employee ? "Yes" : "No" }}</td>
                  <td>{{ family.is_student ? "Yes" : "No" }}</td>
                  <td>{{ family.mobile_no }}</td>
                  <td>{{ family.email }}</td>
                  <td>{{ family.remarks }}</td>
                  <td v-if="showActionColumn">
                    <jb-button
                      v-if="checkUser"
                      color="danger"
                      :icon="mdiTrashCan"
                      small
                      @click="deleteFile(family, 'family')"
                    />
                    <jb-button
                      v-if="checkUser"
                      class="mb-2"
                      color="info"
                      :icon="mdiCircleEditOutline"
                      small
                      @click="editData('Family', family)"
                    />
                    <jb-button
                      class="mb-2"
                      color="warning"
                      :icon="mdiMagnify"
                      small
                      @click="detailData('Family', family)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="activeTab === 11" class="table-container">
          <div class="flex flex-wrap -mx-3 mb-1 w-8/12">
            <field
              :label="$t('presence.month') + '/' + $t('presence.year')"
              class="w-full md:w-2/2 px-2 mb-3 md:mb-1"
            >
              <datepicker
                v-model="filter.date"
                :enableTimePicker="false"
                name="date"
                monthPicker
              />
              <jb-button
                label="Process"
                color="info"
                :icon="mdiMagnify"
                small
                @click="filterData"
              />
            </field>
          </div>
          <table class="table border-dashed w-full col-span-2">
            <thead>
              <tr>
                <td>{{ $t("academicyear.date") }}</td>
                <td>{{ $t("day.title") }}</td>
                <td>{{ $t("presence.in") }}</td>
                <td>{{ $t("presence.out") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(value, key) in presenceData.value"
                :key="key"
                :style="value !== null ? value[3] : ''"
              >
                <td v-if="key === 'total_present'">
                  {{ $t("newbatchregis.total") + " " + $t("presence.title") }}
                </td>
                <td v-else-if="key === 'total_tardy'">
                  {{ $t("newbatchregis.total") + " " + $t("presence.tardy") }}
                </td>
                <td v-else-if="key === 'total_libur'">
                  {{ $t("newbatchregis.total") + " " + $t("presence.holiday") }}
                </td>
                <td v-else>{{ key }}</td>

                <td
                  v-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '0'
                  "
                >
                  {{ $t("day.sunday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '1'
                  "
                >
                  {{ $t("day.monday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '2'
                  "
                >
                  {{ $t("day.tuesday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '3'
                  "
                >
                  {{ $t("day.wednesday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '4'
                  "
                >
                  {{ $t("day.thursday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '5'
                  "
                >
                  {{ $t("day.friday") }}
                </td>
                <td
                  v-else-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[0] === '6'
                  "
                >
                  {{ $t("day.saturday") }}
                </td>
                <td v-else></td>

                <td
                  v-if="
                    value !== null &&
                    typeof value[1] === 'string' &&
                    value[1].includes('late')
                  "
                >
                  <span
                    class="relative inline-block px-3 py-1 font-semibold text-red-900 leading-tight"
                  >
                    <span
                      aria-hidden
                      class="absolute inset-0 bg-red-200 opacity-50 rounded-full"
                    />
                    <span class="relative">
                      {{ value[1].replace("late", "") }}
                    </span>
                  </span>
                </td>
                <td v-else-if="value !== null">{{ value[1] }}</td>
                <td v-else></td>

                <td v-if="value !== null">{{ value[2] }}</td>
                <td v-else></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="activeTab === 12" class="table-container">
          <div class="mt-5">
            <calendar-attendance :prop-object="employee" />
          </div>
        </div>
        <div v-if="activeTab === 13" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('attachment')"
            />
            <jb-button
              class="mb-2"
              color="warning"
              label="Download"
              :icon="mdiDownload"
              small
              @click="downloadAllPDFs('attachment')"
            />
          </div>
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false" class="mb-4">
              Menu: <i>Attachment</i>
            </p>
            <table class="table border-dashed w-full col-span-2 mb-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>{{ $t("vaccines.description") }}</td>
                  <td>{{ $t("candidate.submenu") }}</td>
                  <td>{{ $t("lessonplan.file") }}</td>
                  <td v-if="showActionColumn">Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(attachment, index) in attachmentData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ attachment.description }}</td>
                  <td>{{ attachment.submenu }}</td>
                  <td>{{ attachment.file }}</td>
                  <td v-if="showActionColumn">
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(attachment, 'employeeattachment')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('', attachment)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('', attachment)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeTab === 14" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('Appreciation')"
            />
            <jb-button
              class="mb-2"
              color="warning"
              label="Download"
              :icon="mdiDownload"
              small
              @click="downloadAllPDFs('Appreciation')"
            />
          </div>
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false" class="mb-4">
              Menu: <i>Appreciation</i>
            </p>
            <table class="table border-dashed w-full col-span-2 mb-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Certificate Date</td>
                  <td>Achievement</td>
                  <td>Expired Date</td>
                  <td>File</td>
                  <td v-if="showActionColumn">Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(appreciation, index) in appreciationData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ appreciation.certificate_date }}</td>
                  <td>{{ appreciation.achievement }}</td>
                  <td>{{ appreciation.expired_date }}</td>
                  <td>{{ appreciation.file }}</td>
                  <td v-if="showActionColumn">
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(appreciation, 'employeappreciation')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Appreciation', appreciation)"
                      />
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('Appreciation', appreciation)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeTab === 15" class="table-container">
          <!-- <div class="w-full flex justify-center items-center gap-2">
            <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('punishmentTransaction')"
            />
          </div> -->
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false" class="mb-4">
              Menu: <i>Warning</i>
            </p>
            <table class="table border-dashed w-full col-span-2 mb-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>Number</td>
                  <td>Violation</td>
                  <td>Punishment</td>
                  <td>Transaction Date</td>
                  <td>Expired Date</td>
                  <td>Decree No</td>
                  <td>File Name</td>
                  <td>Remarks</td>
                  <td>Proposed By</td>
                  <td>HR Pic 1</td>
                  <td>HR Pic 2</td>
                  <td>Witness 1</td>
                  <td>Witness 2</td>
                  <td v-if="showActionColumn">Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(
                    punishmentTransaction, index
                  ) in punishmentTransactionData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ punishmentTransaction.number }}</td>
                  <td>{{ punishmentTransaction.violation_description }}</td>
                  <td>{{ punishmentTransaction.punishment_description }}</td>
                  <td>{{ punishmentTransaction.transaction_date }}</td>
                  <td>{{ punishmentTransaction.expired_date }}</td>
                  <td>{{ punishmentTransaction.decree_no }}</td>
                  <td>{{ punishmentTransaction.file_name }}</td>
                  <td>{{ punishmentTransaction.remarks }}</td>
                  <td>{{ punishmentTransaction.proposed_by_name }}</td>
                  <td>{{ punishmentTransaction.pic1_name }}</td>
                  <td>{{ punishmentTransaction.pic2_name }}</td>
                  <td>{{ punishmentTransaction.witness1_name }}</td>
                  <td>{{ punishmentTransaction.witness2_name }}</td>
                  <td v-if="showActionColumn">
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <!-- <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(violation, 'employeviolation')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('Violation', violation)"
                      /> -->
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="
                          detailData(
                            'punishmentTransaction',
                            punishmentTransaction
                          )
                        "
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiFileSearchOutline"
                        small
                        @click="
                          viewFile(
                            'punishmentTransaction',
                            punishmentTransaction.id
                          )
                        "
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeTab === 16" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <!-- <jb-button
              v-if="checkUser"
              class="mb-2"
              label="Add"
              color="info"
              :icon="mdiPlusCircleOutline"
              small
              @click="addData('programme')"
            /> -->
            <jb-button
              class="mb-2"
              color="warning"
              label="Download"
              :icon="mdiDownload"
              small
              @click="downloadAllPDFs('programme')"
            />
          </div>
          <div ref="modalContent" class="overflow-x-auto whitespace-nowrap">
            <p v-if="showActionColumn == false" class="mb-4">
              Menu: <i>programme</i>
            </p>
            <table class="table border-dashed w-full col-span-2 mb-2">
              <thead>
                <tr>
                  <td>No</td>
                  <td>School</td>
                  <td>Branch</td>
                  <td>Academic Year</td>
                  <td>Code</td>
                  <td>Name</td>
                  <td>Description</td>
                  <td>Start Date</td>
                  <td>End Date</td>
                  <td>File</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(programme, index) in programmeData.value"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ programme.school_name }}</td>
                  <td>{{ programme.branch_name }}</td>
                  <td>{{ programme.academic_year_name }}</td>
                  <td>{{ programme.code }}</td>
                  <td>{{ programme.name }}</td>
                  <td>{{ programme.description }}</td>
                  <td>{{ programme.start_date }}</td>
                  <td>{{ programme.end_date }}</td>
                  <td>{{ programme.file_name }}</td>
                  <td>
                    <jb-buttons type="justify-start lg:justify-end" no-wrap>
                      <!-- <jb-button
                        v-if="checkUser"
                        color="danger"
                        :icon="mdiTrashCan"
                        small
                        @click="deleteFile(programme, 'programme')"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiCircleEditOutline"
                        small
                        @click="editData('programme', programme)"
                      /> -->
                      <jb-button
                        class="mb-2"
                        color="warning"
                        :icon="mdiMagnify"
                        small
                        @click="detailData('programme', programme)"
                      />
                      <jb-button
                        v-if="checkUser"
                        class="mb-2"
                        color="info"
                        :icon="mdiFileSearchOutline"
                        small
                        @click="viewFile('programme', programme.id)"
                      />
                    </jb-buttons>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="activeTab === 17" class="table-container">
          <div class="w-full flex justify-center items-center gap-2">
            <!-- <jb-button class="mb-2" label="Add" color="info" :icon="mdiPlusCircleOutline" small
                            @click="addData('Assesment')" /> -->
          </div>
          <div ref="modalContent"></div>
        </div>
      </div>

      <div class="flex gap-4 justify-center border-t p-4">
        <button
          class="py-2 px-4 border rounded-md border-blue-600 text-blue-600 cursor-pointer uppercase text-sm font-bold hover:bg-blue-500 hover:text-white hover:shadow"
          @click="activeTab--"
          v-if="activeTab > 0"
        >
          Back
        </button>
        <button
          class="py-2 px-4 border rounded-md border-blue-600 text-blue-600 cursor-pointer uppercase text-sm font-bold hover:bg-blue-500 hover:text-white hover:shadow"
          @click="activeTab++"
          v-if="activeTab < tabs.length - 1"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import { ref, reactive, watchEffect, onMounted, computed, watch } from "vue";
import StudentAvatar from "@/components/StudentAvatar";
import Level from "@/components/Level";
import CardComponent from "@/components/CardComponent";
import { useStore } from "vuex";
// Form
import UploadForm from "@/views/referensi/employee/UploadForm";
import PositionForm from "@/views/referensi/employee/PositionForm";
import BranchForm from "@/views/referensi/employee/BranchForm";
import ContractForm from "@/views/referensi/employee/ContractForm";
import RetirementForm from "@/views/referensi/employee/RetirementForm";
import EduForm from "@/views/referensi/employee/EduForm";
import CertificationForm from "@/views/referensi/employee/CertificationForm";
import WorkForm from "@/views/referensi/employee/WorkForm";
import FamilyForm from "@/views/referensi/employee/FamilyForm";
import AppreciationForm from "@/views/referensi/employee/AppreciationForm";
import ViolationForm from "@/views/referensi/employee/ViolationForm";
import PunishmentTransactionForm from "@/views/humanresource/punishmentTransaction/PunishmentTransactionForm";
import AssignmentForm from "@/views/referensi/employee/AssignmentForm";
import EmployeeCareerPathForm from "@/views/referensi/employeeCareerPath/EmployeeCareerPathForm";
import EmployeeTrainingForm from "@/views/humanresource/employeetraining/EmployeeTrainingForm";
import ProgrammeForm from "@/views/humanresource/programme/ProgrammeForm";
// Detail
import PositionDetail from "@/views/referensi/employee/PositionDetail";
import BranchDetail from "@/views/referensi/employee/BranchDetail";
import ContractDetail from "@/views/referensi/employee/ContractDetail";
import UploadDetail from "@/views/referensi/employee/UploadDetail";
import RetirementDetail from "@/views/referensi/employee/RetirementDetail";
import EduDetail from "@/views/referensi/employee/EduDetail";
import CertificationDetail from "@/views/referensi/employee/CertificationDetail";
import WorkDetail from "@/views/referensi/employee/WorkDetail";
import FamilyDetail from "@/views/referensi/employee/FamilyDetail";
import AppreciationDetail from "@/views/referensi/employee/AppreciationDetail";
import ViolationDetail from "@/views/referensi/employee/ViolationDetail";
import PunishmentTransactionDetail from "@/views/humanresource/punishmentTransaction/PunishmentTransactionDetail";
import AssignmentDetail from "@/views/referensi/employee/AssignmentDetail";
import EmployeeCareerPathDetail from "@/views/referensi/employeeCareerPath/EmployeeCareerPathDetail";
import EmployeeTrainingDetail from "@/views/humanresource/employeetraining/EmployeeTrainingDetail";
import ProgrammeDetail from "@/views/humanresource/programme//ProgrammeDetail";
import Pill from "@/components/Pill";
import ButtonActive from "@/components/ButtonActive";
import JbButton from "@/components/JbButton";
import Field from "@/components/Field";
import Control from "@/components/Control";
import {
  mdiCheckDecagram,
  mdiAlertDecagram,
  mdiPlusCircleOutline,
  mdiClose,
  mdiDownload,
  mdiTrashCan,
  mdiCircleEditOutline,
  mdiMagnify,
  mdiCheckCircle,
  mdiFileSearchOutline,
} from "@mdi/js";
import { getShift } from "@/composables/global";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main\.css";
import { useToast } from "vue-toastification";
import Loading from "vue-loading-overlay";
import html2pdf from "html2pdf.js";
import CryptoJS from "crypto-js";
import VuePdfEmbed from "vue-pdf-embed";
// Calendar
import CalendarAttendance from "@/views/referensi/employee/CalendarAttendance";

export default {
  name: "ClassForm",
  components: {
    CalendarAttendance,
    StudentAvatar,
    Datepicker,
    Field,
    Control,
    Level,
    UploadForm,
    PositionForm,
    BranchForm,
    ContractForm,
    RetirementForm,
    EduForm,
    CertificationForm,
    WorkForm,
    FamilyForm,
    AppreciationForm,
    ViolationForm,
    PunishmentTransactionForm,
    AssignmentForm,
    EmployeeCareerPathForm,
    EmployeeTrainingForm,
    ProgrammeForm,
    ProgrammeDetail,
    EmployeeTrainingDetail,
    PositionDetail,
    BranchDetail,
    ContractDetail,
    UploadDetail,
    RetirementDetail,
    EduDetail,
    CertificationDetail,
    WorkDetail,
    FamilyDetail,
    AppreciationDetail,
    ViolationDetail,
    PunishmentTransactionDetail,
    AssignmentDetail,
    EmployeeCareerPathDetail,
    CardComponent,
    JbButton,
    ButtonActive,
    Pill,
    Loading,
    html2pdf,
    VuePdfEmbed,
  },

  props: {
    propClass: { type: Object, default: () => ({ empty: true }) },
    isBranch: { type: Boolean, default: false },
    isDecree: { type: Boolean, default: false },
    isContract: { type: Boolean, default: false },
    isDocument: { type: Boolean, default: false },
    propId: { type: String, default: null },
  },

  emits: ["close-modal", "submit"],

  methods: {
    downloadAllPDFs(type) {
      let data;
      switch (type) {
        case "Position":
          data = this.positionData.value;
          break;
        case "Branch":
          data = this.branchData.value;
          break;
        case "Contract":
          data = this.contractData.value;
          break;
        case "Training":
          data = this.TrainingData.value;
          break;
        case "Education":
          data = this.educationData.value;
          break;
        case "Certification":
          data = this.certificateData.value;
          break;
        case "Work":
          data = this.workingData.value;
          break;
        case "attachment":
          data = this.attachmentData.value;
          break;
        case "Appreciation":
          data = this.appreciationData.value;
          break;
        case "Assignment":
          data = this.assignmentData.value;
          break;
        case "CareerPath":
          data = this.employeeCareerPathData.value;
          break;
        default:
          data = [];
      }
      data.forEach((item) => {
        const link = document.createElement("a");
        link.href = item.filename;
        link.download = `${item.file ? item.file : item.file_name}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);
    const activeTab = ref(0);
    const uploadModal = ref(false);
    const detailModal = ref(false);
    const toast = useToast();
    const where = reactive({
      ein: "",
      submenu: "",
      nickname: "",
    });
    const { shiftList } = getShift();
    const presenceData = reactive([]);
    const positionData = reactive([]);
    const viewFileModal = ref(false);
    const employeeCareerPathData = reactive([]);
    const branchData = reactive([]);
    const contractData = reactive([]);
    const educationData = reactive([]);
    const certificateData = reactive([]);
    const workingData = reactive([]);
    const familyData = reactive([]);
    const retireData = reactive([]);
    const attachmentData = reactive([]);
    const TrainingData = reactive([]);
    const employeeTrainingData = reactive([]);
    const appreciationData = reactive([]);
    const violationData = reactive([]);
    const punishmentTransactionData = reactive([]);
    const assignmentData = reactive([]);
    const programmeData = reactive([]);
    const fileidcard = ref("");
    const filefamilycard = ref("");
    const filepassport = ref("");
    const filetin = ref("");
    const str = useStore();
    const userlogin = localStorage.getItem("name");
    const isLoading = ref(false);

    const employee = reactive({
      id: "",
      description: "",
      photo: "",
      created_by: "",
    });
    const filter = reactive({
      shift_id: "",
      date: {
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
      },
    });

    const details = async (evt) => {
      isLoading.value = true;
      const params = reactive({
        id: evt,
      });
      await axios
        .get("employeedetails", {
          params: params,
        })
        .then((response) => {
          // assign state kelass with response data
          positionData.value = response.data.position;
          branchData.value = response.data.branch;
          contractData.value = response.data.contract;
          // salaryData.value = response.data.salary
          educationData.value = response.data.school;
          certificateData.value = response.data.certificate;
          workingData.value = response.data.workexp;
          familyData.value = response.data.family;
          retireData.value = response.data.retire;
          // attachmentData.value = response.data.attachment
          TrainingData.value = response.data.attachment.filter(
            (item) => item.submenu == "Training"
          );
          attachmentData.value = response.data.attachment.filter(
            (item) => item.submenu !== "Training"
          );
          appreciationData.value = response.data.appreciation;
          assignmentData.value = response.data.assignment;
          employeeCareerPathData.value = response.data.employeecareerpath;
          employeeTrainingData.value = response.data.employeetraining;
          programmeData.value = response.data.programme;
          punishmentTransactionData.value = response.data.punishmentTransaction;
          violationData.value = response.data.violation;

          isLoading.value = false;
        })
        .catch((error) => {
          console.log(error);
        });
    };

    const filterData = async () => {
      isLoading.value = true;
      const params = reactive({
        id: props.propId,
        shift_id: filter.shift_id,
        work_unit_id: employee.work_unit_id,
        month: filter.date.month + 1,
        year: filter.date.year,
      });
      // console.log("cek get presence", params);
      await axios
        .get("presenceemployee", {
          params: params,
        })
        .then((response) => {
          // assign state kelass with response data
          isLoading.value = false;
          presenceData.value = response.data.data[0];
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const hideModal = () => {
      uploadModal.value = false;
      details(props.propId);
    };

    const onFileChange = async (event, evt) => {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 1024 * 1024) {
          alert("File too big (> 1MB)");
          file.value = "";
        } else {
          const reader = new FileReader();
          reader.onloadend = function () {
            if (evt === "idcard") {
              fileidcard.value = reader.result;
            } else if (evt === "familycard") {
              filefamilycard.value = reader.result;
            } else if (evt === "passport") {
              filepassport.value = reader.result;
            } else {
              filetin.value = reader.result;
            }
          };
          reader.readAsDataURL(file);
        }
      } else {
        fileidcard.value = "";
      }
    };

    const showActionColumn = ref(true);

    const modalContent = ref(null);

    const download = async (submenu) => {
      isLoading.value = false;
      showActionColumn.value = false;
      const currentDate = new Date().toISOString().slice(0, 10);
      const content = modalContent.value;
      html2pdf(content, {
        margin: 0.5,
        filename: `${currentDate}_${submenu}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          width: 8.5,
        },
      })
        .then(() => {
          isLoading.value = false;
          showActionColumn.value = true;
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
          isLoading.value = false;
        });
    };

    const deleteFile = (evt, url) => {
      isLoading.value = true;
      axios
        .delete(`${url}/${evt.id}`)
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            toast.success(response.data.message, { timeout: 5000 });
          } else {
            toast.error(response.data.message, { timeout: 5000 });
          }
          isLoading.value = false;
        })
        .catch((error) => {
          console.log(error);
          details(props.propId);
          toast.error(error.response.data.message, { timeout: 5000 });

          isLoading.value = false;
        });
    };

    const addData = (evt) => {
      uploadModal.value = true;
      where.submenu = evt;
      where.ein = employee.ein;
      where.nickname = employee.nickname;
      where.employee_id = props.propId;
      showEdit.value = false;
    };

    const showEdit = ref(false);

    const EditObject = ref();

    const editData = (submenuValue, position) => {
      uploadModal.value = true;
      where.submenu = submenuValue;
      where.ein = employee.ein;
      where.nickname = employee.nickname;
      where.employee_id = props.propId;
      EditObject.value = position;
      showEdit.value = true;
    };

    const detailData = (submenuValue, position) => {
      // alert('Detail Data')
      where.submenu = submenuValue;
      // where.ein = employee.ein
      // where.nickname = employee.nickname
      // where.employee_id = props.propId
      detailModal.value = true;
      EditObject.value = position;

      // console.log("editObject.value", EditObject.value);
    };

    const image = reactive({
      get: null,
    });

    const getPhoto = () => {
      // console.log(" employee id GET PHOTO", props.propId);
      axios
        .get("get-photo-employee", {
          params: { id: props.propId },
        })
        .then((res) => {
          if (res.data.success) {
            image.get = res.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
          // getPhotoDoc()
        });
    };

    const userRole = localStorage.getItem("roles");

    const checkUser = ref(true);

    const userCheck = async () => {
      if (userRole !== null) {
        const decryptedMessage = CryptoJS.AES.decrypt(
          localStorage.getItem("role"),
          "amatra1609"
        ).toString(CryptoJS.enc.Utf8);
        const myArray = decryptedMessage.split(",");
        for (let i = 0; i < myArray.length; i++) {
          if (myArray[i] === "ROLE_MANAGEMENT") {
            checkUser.value = false;
          }
        }
      }
    };

    const headers = { "Content-Encoding": "gzip" };

    const fetchData = async () => {
      isLoading.value = true;
      const params = reactive({
        id: props.propId,
      });

      try {
        const [responseEmployeeDetail] = await Promise.all([
          axios.get("employeedetails", { headers, params: params }),
        ]);
        if (responseEmployeeDetail.data.success) {
          positionData.value = responseEmployeeDetail.data.position;
          branchData.value = responseEmployeeDetail.data.branch;
          contractData.value = responseEmployeeDetail.data.contract;
          // salaryData.value = responseEmployeeDetail.data.salary
          educationData.value = responseEmployeeDetail.data.school;
          certificateData.value = responseEmployeeDetail.data.certificate;
          workingData.value = responseEmployeeDetail.data.workexp;
          familyData.value = responseEmployeeDetail.data.family;
          retireData.value = responseEmployeeDetail.data.retire;
          // attachmentData.value = responseEmployeeDetail.data.attachment
          TrainingData.value = responseEmployeeDetail.data.attachment.filter(
            (item) => item.submenu == "Training"
          );
          attachmentData.value = responseEmployeeDetail.data.attachment.filter(
            (item) => item.submenu !== "Training"
          );
          appreciationData.value = responseEmployeeDetail.data.appreciation;
          assignmentData.value = responseEmployeeDetail.data.assignment;
          employeeCareerPathData.value =
            responseEmployeeDetail.data.employeecareerpath;
          employeeTrainingData.value =
            responseEmployeeDetail.data.employeetraining;
          programmeData.value = responseEmployeeDetail.data.programme;
          punishmentTransactionData.value =
            responseEmployeeDetail.data.punishmentTransaction;
          violationData.value = responseEmployeeDetail.data.violation;
        }
        isLoading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "-";
      return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(new Date(dateStr));
    };

    onMounted(() => {
      userCheck();
    });

    watchEffect(() => {
      const newemployee = props.propClass;
      Object.assign(employee, newemployee);

      if (props.isDecree) {
        activeTab.value = 2;
      }

      if (props.isDocument) {
        activeTab.value = 8;
      }

      if (props.isContract) {
        activeTab.value = 6;
      }
    });

    watch(
      () => props.propId,
      (newVal, oldVal) => {
        // console.log("Get id employee", newVal);

        if (props.propId) {
          getPhoto(props.propId);
        } else {
          image.get = null;
        }
        // details(newVal);
        // filterData();
        fetchData();
      }
    );

    watch(
      () => props.isBranch,
      (newVal, oldVal) => {
        if (props.isBranch) {
          activeTab.value = 3;
        }
      }
    );

    // watch(
    //   () => props.isDecree,
    //   (newVal, oldVal) => {
    //     console.log("cel decre ges", props.isDecree)
    //     if (props.isDecree) {
    //       activeTab.value = 2;
    //     }
    //   }
    // );

    // watch(
    //   () => props.isDocument,
    //   (newVal, oldVal) => {
    //     if (props.isDocument) {
    //       activeTab.value = 8;
    //     }
    //   }
    // );

    const mainup = reactive({
      id: "",
      employee_id: "",
      is_main: true,
      department_name: "",
      position_name: "",
      updated_by: "",
    });
    const informationModal = ref(false);
    const updateMainData = (is_main, data) => {
      informationModal.value = true;
      mainup.id = data.id;
      mainup.employee_id = data.employee_id;
      mainup.is_main = is_main;
      mainup.department_name = data.department_name;
      mainup.position_name = data.position_name;
      mainup.updated_by = userlogin;
    };

    const updateMain = () => {
      isLoading.value = true;
      const url = "employeeposition-main";
      const method = "POST";
      const params = mainup;
      // console.log("params", params);

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            informationModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    const positionActiveModal = ref(false)
    const isActiveData = reactive({
      id: "",
      employee_id: "",
      is_active: true,
      updated_by: "",
    }); 

    const updateActiveData = (is_active, data) => {
      positionActiveModal.value = true;
      isActiveData.id = data.id;
      isActiveData.employee_id = data.employee_id;
      isActiveData.position_id = data.position_id
      isActiveData.tmt = data.tmt
      isActiveData.is_main = data.is_main
      isActiveData.is_active = is_active
      isActiveData.updated_by = userlogin;
    };
 
    const updateIsActive = () => {
      isLoading.value = true;
      const url = "employeeposition/"+isActiveData.id;
      const method = "PUT";
      const params = isActiveData;
      // console.log("params", params);

      const jsonData = JSON.stringify(params);

      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      };

      axios({
        method,
        url,
        data: jsonData,
        headers: configHeaders,
      })
        .then((response) => {
          if (response.data.success) {
            details(props.propId);
            positionActiveModal.value = false;
            toast.success(response.data.message);
          } else {
            isLoading.value = false;
            toast.error(response.data.message);
          }
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };


    const viewFile = (event, id) => {
      viewFileModal.value = true;
      viewFileModal.id = id;
      getFile();
    };

    const fileData = ref({
      file: "",
      type: "",
    });

    const getFile = async () => {
      isLoading.value = true;
      await axios
        .get("show-file-punishment/" + viewFileModal.id)
        .then((response) => {
          if (response.data.success) {
            fileData.value = response.data.data;
          } else {
            fileData.value = [];
          }
          isLoading.value = false;
        })
        .catch((error) => {
          isLoading.value = false;
          console.log(error);
        });
    };

    return {
      checkUser,
      updateMain,
      updateMainData,
      updateActiveData,
      updateIsActive,
      informationModal,
      positionActiveModal,
      mainup,
      activeTab,
      tabs: [
        { index: 0, name: "Personal" },
        { index: 1, name: "Position" },
        { index: 2, name: "Career Path" },
        { index: 3, name: "Branch" },
        { index: 4, name: "Retirement" },
        { index: 5, name: "Training" },
        { index: 6, name: "Contract" },
        { index: 7, name: "Educational Record" },
        { index: 8, name: "Certification" },
        { index: 9, name: "Working Experiences" },
        { index: 10, name: "Family" },
        { index: 11, name: "Attendance" },
        { index: 12, name: "Attendance Calendar" },
        { index: 13, name: "Personal Document" },
        { index: 14, name: "Appreciation" },
        { index: 15, name: "Warning" },
        { index: 16, name: "Assignment" },
        { index: 17, name: "Assesment" },
      ],
      titleStack,
      shiftList,
      str,
      userlogin,
      uploadModal,
      toast,
      where,
      filter,
      filterData,
      hideModal,
      onFileChange,
      download,
      deleteFile,
      addData,
      editData,
      detailData,
      detailModal,
      viewFileModal,
      viewFile,
      EditObject,
      showEdit,
      mdiCheckDecagram,
      mdiClose,
      mdiAlertDecagram,
      mdiPlusCircleOutline,
      mdiDownload,
      mdiTrashCan,
      mdiCircleEditOutline,
      mdiCheckCircle,
      mdiMagnify,
      mdiFileSearchOutline,
      employee,
      presenceData,
      // trainingData,
      positionData,
      employeeCareerPathData,
      employeeTrainingData,
      programmeData,
      punishmentTransactionData,
      branchData,
      contractData,
      educationData,
      certificateData,
      workingData,
      familyData,
      TrainingData,
      appreciationData,
      violationData,
      retireData,
      attachmentData,
      assignmentData,
      getPhoto,
      fileData,
      image,
      modalContent,
      showActionColumn,
      isLoading,
      formatDate,
      // salaryData
    };
  },
};
</script>
<style>
.table-container {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border: 2px dashed #cccccc;
  margin-bottom: 1em;
  font-family: Arial, sans-serif;
}

.table th,
.table td {
  padding: 0.75em;
  text-align: left;
  border-bottom: 1px dashed #cccccc;
}

.table th {
  background-color: #f8f8f8;
  font-weight: bold;
}

.table tbody tr:hover {
  background-color: #f1f1f1;
}

.table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table-buttons {
  display: flex;
  justify-content: flex-end;
}

.table-buttons jb-button {
  margin-left: 0.5em;
}

.student-tab {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  position: relative;

  .tab-list {
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow-x: auto;
    /* // display: flex; */
    /* // justify-content: center; */
    margin-bottom: 28px;
    position: sticky;
    z-index: 15;
    top: 0;
    padding: 20px 0px 8px 0px;

    .tab-container {
      width: max-content;
      margin: 0 auto;

      .content-tab {
        width: max-content;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        p {
          width: 100%;
          font-size: 14px;
          line-height: 24px;
          color: gray;
          padding: 0 16px;
          margin-bottom: 8px;
          transition: color 0.5s, font-weight 0.5s;
        }

        .line-tab {
          width: 100%;
          height: 8px;
          background-color: rgb(214, 214, 214);
          transition: background-color 0.5s;
        }
      }

      .active-tab {
        p {
          font-weight: 600;
          color: rgb(2, 198, 2);
        }

        .line-tab {
          background-color: rgb(2, 198, 2);
        }
      }
    }
  }

  .data-container {
    width: 100%;
    max-width: 100%;
    min-height: 70vh;
    height: auto;
    padding: 20px;
    position: relative;
    z-index: 13;
    /* // overflow-x: auto; */

    .data-content {
      width: 100%;
      max-width: 100%;
      min-height: max-content;
      height: auto;
      /* // padding-bottom: 160px; */
      overflow-x: auto;

      table {
        min-width: 100%;
        width: max-content;
        table-layout: fixed;
        overflow-wrap: break-word;
        word-wrap: break-word;

        thead {
          tr {
            th {
              font-size: 14px;
              line-height: 24px;
            }
          }
        }

        tbody {
          tr {
            td {
              font-size: 14px;
              line-height: 24px;
              letter-spacing: 0.6px;
              word-spacing: 2px;
              vertical-align: top;
              word-wrap: break-word !important;
              white-space: normal !important;
              word-break: break-all !important;
            }
          }
        }
      }
    }

    .single-table {
      /* table {
                // thead {
                //     tr {
                //         th {

                //         }
                //     }
                // } */

      tbody {
        tr {
          td {
            padding: 8px 12px;
            transition: background-color 0.3s;
            word-wrap: break-word !important;
            white-space: normal !important;
            word-break: break-all !important;

            &:nth-child(1) {
              width: 240px;
              border-right: 1px solid lightgray;

              @media (min-width: 768px) {
                position: sticky;
                left: 0;
              }
            }

            &:nth-child(2) {
              font-weight: 700;
            }
          }

          &:nth-child(even) {
            td {
              background-color: rgb(246, 246, 246);
            }
          }

          &:nth-child(odd) {
            td {
              background-color: white;
            }
          }

          &:hover {
            td {
              background-color: rgb(222, 239, 255);
            }
          }
        }
      }
    }
  }

  .double-same-table {
    table {
      thead {
        tr {
          th {
            text-align: center;
          }
        }
      }

      tbody {
        tr {
          td {
            padding: 8px 12px;
            transition: background-color 0.3s;
            border-right: 1px solid lightgray;
            word-wrap: break-word !important;
            white-space: normal !important;
            word-break: break-all !important;

            &:nth-child(1) {
              width: 160px;
            }

            &:nth-child(2) {
              font-weight: 700;
            }

            &:nth-child(3) {
              font-weight: 700;
            }

            &:nth-last-child(1) {
              border-right: none;
            }
          }

          &:nth-child(even) {
            td {
              background-color: rgb(246, 246, 246);
            }
          }

          &:hover {
            td {
              background-color: rgb(222, 239, 255);
            }
          }
        }
      }
    }
  }
}
</style>
